import { obj } from '../models/common-types';

export const PENDO_EVENTS = {
    SEARCH_ALL: 'Search-all',
    SEARCH_FORM_EMAIL: 'Search-form-email',
    SEARCH_FORM_NAME: 'Search-form-name',
    SEARCH_FORM_PHONE: 'Search-form-phone',
    SEARCH_FORM_SOCIAL_ACCOUNT: 'Search-form-social account',
    SEARCH_POSSIBLE_MATCHES_MULTI_SELECT: 'Search-possible matches-multi select',
    SEARCH_POSSIBLE_MATCHES_ACCOUNT: 'Search-possible matches-account',
    SEARCH_REPORT_NAMES: 'Search-report-names',
    SEARCH_REPORT_PHONES: 'Search-report-phones',
    SEARCH_REPORT_EMAILS: 'Search-report-emails',
    SEARCH_REPORT_SOCIAL_PRESENCE: 'Search-report-social presence',
    SEARCH_REPORT_CONNECTION_OPTION: 'Search-report-connection-option',
    SEARCH_POSSIBLE_MATCHES_NAMES: 'Search-possible matches-names',
    SEARCH_POSSIBLE_MATCHES_PHONES: 'Search-possible matches-phones',
    SEARCH_POSSIBLE_MATCHES_EMAILS: 'Search-possible matches-emails',
    ADD_TO_REPORT_POSSIBLE_MATCHES_MULTI_SELECT: 'Add to report-possible matches-multi select',
    ADD_TO_REPORT_REPORT_PHONES: 'Add to report-report-phones',
    ADD_TO_REPORT_REPORT_EMAILS: 'Add to report-report-emails',
    ADD_TO_REPORT_POSSIBLE_MATCHES_ACCOUNT: 'Add to report-possible matches-account',
    ADD_TO_REPORT_POSSIBLE_MATCHES_PHONES: 'Add to report-possible matches-phones',
    ADD_TO_REPORT_POSSIBLE_MATCHES_EMAILS: 'Add to report-possible matches-emails',
    DUPLICATE_COLLECTION_OPTION: 'Duplicate collection-option',
    DUPLICATE_COLLECTION_MULTI_SELECT: 'Duplicate collection-multi select',
    MOVE_COLLECTIONS_OPTION: 'Move collections-option',
    MOVE_COLLECTIONS_MULTI_SELECT: 'Move collections-multi select',
    CREATE_CASE: 'Create case',
    CREATE_SUB_CASE: 'Create sub case',
    GET_MORE_POSTS: 'Get more posts',
};

export const pendoTrack = (eventName: string, value: obj<any>) =>
    window.pendo.track(eventName, { ...value, workspace: sessionStorage.getItem('workspace') });
